import Link from './Link';

export default Link;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-link/es/index.js
// module id = 160
// module chunks = 0